// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Iz9H","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__18uwM"};